import React from 'react';
import {useForm} from 'react-hook-form';

import {useAuth} from '../Auth/useAuth';
import ProAccountFieldEdit, {ReferenceDataSelect} from './ProAccountFieldEdit';
import useProSectors from '../Queries/useProSectors';

const SECTOR_ID = 'pro-account-sector';

const ProAccountSector = () => {
  const {authState, updateProfessionalProfile} = useAuth();
  const onSubmit = (data) => updateProfessionalProfile({...authState.user.profile, ...data});
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm();
  const sectorsQuery = useProSectors();

  return (
    <ProAccountFieldEdit handleSubmit={handleSubmit} onSubmit={onSubmit} buttonDisabled={false}>
      <ReferenceDataSelect
        id={SECTOR_ID}
        testId={SECTOR_ID}
        label="Sector"
        placeholder="Select a sector"
        query={sectorsQuery}
        options={sectorsQuery.data}
        defaultValue={authState.user.profile.professional_sector_id ?? ''}
        field={register('professional_sector_id', {required: true})}
        invalid={!!errors.professional_sector_id}
        errorMessage={errors.professional_sector_id && 'Please select your sector.'}
        // The list is this editor's only control, so its failure takes focus.
        focusFirstFailure
      />
    </ProAccountFieldEdit>
  );
};

export default ProAccountSector;
